/*
  reports state
*/
export default {
  // List loading state (drives the Completed/Generating/Archived loaders)
  loading: false,
  list: [],
  dictList: {},
  completedSessions: [],
  intervalId: null
}
